import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap";
import "../controllers";
import "../styles/application.scss";

window.bootstrap = bootstrap;
